import { render, staticRenderFns } from "./BillIcon3.vue?vue&type=template&id=28494798&"
import script from "./BillIcon3.vue?vue&type=script&lang=ts&"
export * from "./BillIcon3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports